import React from 'react';

import { useNavigate } from 'react-router';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useUIContext } from 'state/ui';
import { isExternalLink } from 'utils/is-external-link';
import { getMenuOptionUrl } from 'utils/menu';
import { routes } from 'utils/routing';

import { Tile, TileButton, TileExternal, TileImageWrapper, TileLabel } from './styles';
import { IMenuOptionScrollerTable } from './types';

export const CAROUSEL_HEIGHT = 0;

const MenuOptionScrollerTile: React.FC<IMenuOptionScrollerTable> = ({ section }) => {
  const { buildImageUrl } = useUIContext();
  const navigate = useNavigate();

  const enableDirectAccessToMenu = useFlag(LaunchDarklyFlag.ENABLE_DIRECT_ACCESS_TO_MENU);

  const redirectUrl = section.redirectLink?.locale;
  const image = section.carouselImage;
  const name = section.name?.locale;

  const tileContent = (
    <>
      <TileImageWrapper data-testid="menu-option-scroller-tile-image">
        {image && image.asset && <img src={buildImageUrl(image, { height: 70 })} alt="" />}
      </TileImageWrapper>
      <TileLabel as="span" to={routes.menu} id={section._id}>
        {name}
      </TileLabel>
    </>
  );

  if (enableDirectAccessToMenu) {
    return (
      <TileButton
        data-testid={`menu-option-scroller-tile-${name}`}
        onClick={() => {
          navigate(routes.menu, { state: { sectionId: section._id } });
        }}
      >
        {tileContent}
      </TileButton>
    );
  }

  if (redirectUrl && isExternalLink(redirectUrl)) {
    return (
      <TileExternal href={redirectUrl} data-testid={`menu-option-scroller-tile-${name}`}>
        {tileContent}
      </TileExternal>
    );
  }

  return (
    <Tile
      to={redirectUrl || getMenuOptionUrl(section)}
      $noBorder
      data-testid={`menu-option-scroller-tile-${name}`}
    >
      {tileContent}
    </Tile>
  );
};

export const MainMenuCarouselTile = MenuOptionScrollerTile;
